<template>
  <div class="layout-container">
    <!-- 左侧菜单 -->
    <el-aside :width="isCollapse ? '64px' : '220px'" class="sidebar">
      <div class="logo-section" :class="{ 'is-collapse': isCollapse }">
        <!-- <img src="@/assets/logo.png" alt="Logo" class="sidebar-logo" /> -->
        <transition name="fade">
          <h3 v-show="!isCollapse" class="sidebar-title">道上麦车</h3>
        </transition>
      </div>
      <el-menu
        :default-active="activeMenu"
        class="sidebar-menu"
        :collapse="isCollapse"
        :collapse-transition="false"
      >
        <el-menu-item index="1" @click="handleMenuClick('1', '/home/dashboard')">
          <el-icon>
            <House />
          </el-icon>
          <template #title>
            <span>工作台</span>
          </template>
        </el-menu-item>

        <el-sub-menu index="2">
          <template #title>
 <el-icon><ShoppingCart /></el-icon>
            <span>订单管理</span>
          </template>
          <!-- <el-menu-item index="2-1" @click="handleMenuClick('2-1', '/home/ride')">驾乘单管理</el-menu-item> -->
          <el-menu-item index="2-2" @click="handleMenuClick('2-2', '/home/booking')">预约单管理</el-menu-item>
        </el-sub-menu>

        <el-sub-menu index="3">
          <template #title>
            <el-icon><UserFilled /></el-icon>
            <span>用户管理</span>
          </template>
          <el-menu-item index="3-1" @click="handleMenuClick('3-1', '/home/users')">用户管理</el-menu-item>
        </el-sub-menu>

        <el-sub-menu index="4">
          <template #title>
<el-icon><BellFilled /></el-icon>
            <span>线索管理</span>
          </template>
          <el-menu-item index="4-1" @click="handleMenuClick('4-1', '/home/articles')">线索池管理</el-menu-item>
        </el-sub-menu>
<!-- 
        <el-menu-item index="6" @click="handleMenuClick('6', '/home/settings')">
          <el-icon>
            <Setting />
          </el-icon>
          <template #title>
            <span>系统设置</span>
          </template>
        </el-menu-item> -->
      </el-menu>
    </el-aside>

    <!-- 右侧内容区 -->
    <el-container class="main-container">
      <!-- 顶部导航栏 -->
      <el-header class="header">
        <div class="header-left">
          <el-icon class="menu-icon" @click="toggleCollapse">
            <Fold v-if="!isCollapse" />
            <Expand v-else />
          </el-icon>
          <el-breadcrumb separator="/" class="breadcrumb">
            <el-breadcrumb-item :to="{ path: '/home/dashboard' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-if="breadcrumbItems.length > 0">
              {{ breadcrumbItems[0] }}
            </el-breadcrumb-item>
            <el-breadcrumb-item v-if="breadcrumbItems.length > 1">
              {{ breadcrumbItems[1] }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="header-right">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="user-info">
              <el-avatar :size="32" :src="currentUser.avatar || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'" />
              <span class="username">{{ currentUser.username || '加载中...' }}</span>
              <el-icon class="el-icon--right">
                <ArrowDown />
              </el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="profile">
                  <el-icon><User /></el-icon>
                  个人中心
                </el-dropdown-item>
                <el-dropdown-item command="settings">
                  <el-icon><Setting /></el-icon>
                  账户设置
                </el-dropdown-item>
                <el-dropdown-item divided command="logout">
                  <el-icon><SwitchButton /></el-icon>
                  退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </el-header>

      <!-- 主内容区 -->
      <el-main class="main-content">
        <!-- 标签页导航 -->
        <div class="tabs-container" v-if="openedTabs.length > 0">
          <div class="tabs-wrapper" ref="tabsWrapperRef">
            <div
              v-for="tab in openedTabs"
              :key="tab.key"
              :class="['tab-item', { active: activeTab === tab.key, 'sub-tab': tab.isSubTab }]"
              @click="switchTab(tab.key)"
            >
              <!-- 子标签显示 tooltip -->
              <el-tooltip v-if="tab.isSubTab" :content="tab.title" placement="top" :show-after="200">
                <span class="tab-title">{{ tab.title }}</span>
              </el-tooltip>
              <!-- 大标签不显示 tooltip -->
              <span v-else class="tab-title">{{ tab.title }}</span>
              
              <el-icon v-if="tab.isSubTab" class="tab-close" @click.stop="closeTab(tab.key)">
                <Close />
              </el-icon>
            </div>
          </div>
        </div>

        <!-- 内容区域 -->
        <div class="content-area">
          <router-view :key="activeTab" />
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'MainLayout'
}
</script>

<script setup>
import { ref, watch, nextTick, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { 
  House, User, Setting, Expand, Fold, ArrowDown, 
  SwitchButton, Close
} from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { removeToken } from '@/utils/request'
import { getUserInfoByToken } from '@/api/user'

const router = useRouter()
const route = useRoute()
const tabsWrapperRef = ref(null)
const isCollapse = ref(false)
const activeMenu = ref('1')
const breadcrumbItems = ref([])
const currentUser = ref({})

// 加载当前用户信息
const loadUserInfo = async () => {
  try {
    const res = await getUserInfoByToken()
    if (res.code === 200 && res.success) {
      currentUser.value = res.data || {}
      // 可以保存到 localStorage 或 Vuex/Pinia
      localStorage.setItem('userInfo', JSON.stringify(res.data))
    } else {
      console.error('获取用户信息失败：', res.msg)
    }
  } catch (error) {
    console.error('获取用户信息失败：', error)
  }
}

// 组件挂载时加载用户信息
onMounted(() => {
  loadUserInfo()
})

// 路由与菜单项的映射关系
const routeMenuMap = {
  '/home/dashboard': '1',
  '/home/ride': '2-1',
  '/home/booking': '2-2',
  '/home/permission': '2-3',
  '/home/users': '3-1',
  '/home/articles': '4-1',
  '/home/media': '4-2',
  '/home/settings': '6'
}

// 路由与面包屑的映射关系
const routeBreadcrumbMap = {
  '/home/dashboard': ['工作台'],
  '/home/ride': ['订单管理', '驾乘单管理'],
  '/home/booking': ['订单管理', '预约单管理'],
  '/home/permission': ['订单管理', '用户权限'],
  '/home/users': ['用户管理', '用户管理'],
  '/home/articles': ['线索管理', '线索池管理'],
  '/home/media': ['线索管理', '媒体库'],
  '/home/settings': ['系统设置']
}

// 监听路由变化，更新菜单激活状态和面包屑
watch(() => [route.path, route.query], ([newPath]) => {
  // 如果是详情/编辑页面，提取基础路径
  let basePath = newPath
  if (newPath.includes('/detail')) {
    basePath = newPath.replace('/detail', '')
  }
  
  // 根据路径设置激活菜单
  const menuIndex = routeMenuMap[basePath]
  if (menuIndex) {
    activeMenu.value = menuIndex
  }
  
  // 更新面包屑
  let breadcrumb = routeBreadcrumbMap[basePath] || []
  
  // 如果是详情/编辑页面，添加额外层级
  if (route.query.mode) {
    const mode = route.query.mode
    if (mode === 'detail') {
      breadcrumb = [...breadcrumb, '详情']
    } else if (mode === 'edit') {
      breadcrumb = [...breadcrumb, '编辑']
    }
  }
  
  breadcrumbItems.value = breadcrumb
}, { immediate: true, deep: true })

// 标签页管理
const openedTabs = ref([])
const activeTab = ref('')
let tabCounter = 0 // 用于生成唯一的标签ID
let isSwitchingTab = false // 标记是否正在切换标签
let shouldScrollToStart = false // 标记是否应该滚动到开头

const toggleCollapse = () => {
  isCollapse.value = !isCollapse.value
}

const handleMenuClick = (index, path) => {
  activeMenu.value = index
  if (path) {
    shouldScrollToStart = true // 设置标志,表示需要滚动到开头
    router.push(path)
  }
}

// 确保主标签存在
const ensureMainTabExists = (detailPath) => {
  // 从详情路径提取基础路径
  let basePath = detailPath.split('?')[0] // 移除查询参数
  if (basePath.includes('/detail')) {
    basePath = basePath.replace('/detail', '')
  }
  
  // 检查是否已存在对应的主标签
  const existingMainTab = openedTabs.value.find(tab => !tab.isSubTab && tab.path === basePath)
  
  if (!existingMainTab) {
    // 移除所有现有的主标签（只保留子标签）
    openedTabs.value = openedTabs.value.filter(tab => tab.isSubTab)
    
    // 根据基础路径获取标题
    const breadcrumb = routeBreadcrumbMap[basePath]
    const title = breadcrumb ? breadcrumb[breadcrumb.length - 1] : '未命名'
    
    // 创建新的主标签并添加到开头
    openedTabs.value.unshift({
      key: basePath,
      title: title,
      path: basePath,
      isSubTab: false
    })
  } else {
    // 如果主标签已存在但不在第一位，需要移除其他主标签
    const otherMainTabs = openedTabs.value.filter(tab => !tab.isSubTab && tab.path !== basePath)
    if (otherMainTabs.length > 0) {
      // 移除其他主标签，只保留当前的主标签和所有子标签
      openedTabs.value = openedTabs.value.filter(tab => tab.isSubTab || tab.path === basePath)
      
      // 确保当前主标签在第一位
      const currentMainTab = openedTabs.value.find(tab => !tab.isSubTab)
      const subTabs = openedTabs.value.filter(tab => tab.isSubTab)
      openedTabs.value = [currentMainTab, ...subTabs]
    }
  }
}

// 监听路由变化，添加标签页
watch(() => route.fullPath, (newPath, oldPath) => {
  // 如果是切换标签导致的路由变化，不创建新标签
  if (isSwitchingTab) {
    isSwitchingTab = false
    return
  }
  
  // 检测是否从详情页返回列表页
  if (oldPath && oldPath.includes('/detail') && !newPath.includes('/detail')) {
    shouldScrollToStart = true // 设置标志,滚动到开头
  }
  
  if (newPath.startsWith('/home/')) {
    // 判断是否为详情/编辑页面
    const isDetailOrEdit = route.query.mode === 'detail' || route.query.mode === 'edit'
    
    let tabKey
    if (isDetailOrEdit) {
      // 详情/编辑页面：先检查是否已存在相同的子标签
      const existingSubTab = openedTabs.value.find(tab => tab.isSubTab && tab.path === newPath)
      
      if (existingSubTab) {
        // 如果已存在相同的子标签，直接切换到该标签
        activeTab.value = existingSubTab.key
        // 确保主标签存在
        ensureMainTabExists(newPath)
        return
      }
      
      // 不存在才创建新标签
      tabCounter++
      tabKey = `${newPath}_${tabCounter}_${Date.now()}`
    } else {
      // 主标签（列表页面）：使用路径作为key
      tabKey = newPath
      
      // 检查是否已存在相同路径的主标签
      const existingMainTab = openedTabs.value.find(tab => !tab.isSubTab && tab.path === newPath)
      if (existingMainTab) {
        // 如果已存在，只切换到该标签，不创建新的
        activeTab.value = existingMainTab.key
        return
      }
      
      // 移除所有现有的主标签（只保留子标签）
      openedTabs.value = openedTabs.value.filter(tab => tab.isSubTab)
    }
    
    // 根据路由生成标签标题
    let title = route.meta.title || '未命名'
    
    // 如果是详情或编辑页面,修改标题格式
    if (route.query.mode) {
      const mode = route.query.mode
      
      // 针对驾乘单详情页特殊处理
      if (route.query.orderNo) {
        if (mode === 'detail') {
          title = `驾乘单-${route.query.orderNo}`
        } else if (mode === 'edit') {
          title = `驾乘单编辑-${route.query.orderNo}`
        }
      } else {
        // 其他页面：优先使用 bookingNo 或 userId,如果没有则使用 id
        const displayId = route.query.bookingNo || route.query.userId || route.query.id
        
        if (mode === 'detail') {
          title = `${title}详情-${displayId}`
        } else if (mode === 'edit') {
          title = `${title}编辑-${displayId}`
        }
      }
    }
    
    // 将新标签添加到开头（主标签）或末尾（子标签）
    if (isDetailOrEdit) {
      // 添加子标签前，确保主标签存在
      ensureMainTabExists(newPath)
      
      openedTabs.value.push({
        key: tabKey,
        title: title,
        path: newPath,
        isSubTab: true
      })
    } else {
      openedTabs.value.unshift({
        key: tabKey,
        title: title,
        path: newPath,
        isSubTab: false
      })
    }
    
    activeTab.value = tabKey
  }
}, { immediate: true })

// 切换标签页
const switchTab = (key) => {
  activeTab.value = key
  const tab = openedTabs.value.find(t => t.key === key)
  if (tab) {
    isSwitchingTab = true // 设置标志，防止创建新标签
    router.push(tab.path)
    
    // 如果是子标签，确保对应的主标签也存在
    if (tab.isSubTab) {
      ensureMainTabExists(tab.path)
    }
  }
}

// 滚动到激活的标签
const scrollToActiveTab = () => {
  nextTick(() => {
    if (!tabsWrapperRef.value) return
    
    // 如果标记为需要滚动到开头,则滚动到开头
    if (shouldScrollToStart) {
      tabsWrapperRef.value.scrollTo({
        left: 0,
        behavior: 'smooth'
      })
      shouldScrollToStart = false // 重置标志
      return
    }
    
    const activeTabElement = tabsWrapperRef.value.querySelector('.tab-item.active')
    if (activeTabElement) {
      // 计算需要滚动的位置
      const container = tabsWrapperRef.value
      const tabLeft = activeTabElement.offsetLeft
      const tabWidth = activeTabElement.offsetWidth
      const containerWidth = container.offsetWidth
      const scrollLeft = container.scrollLeft
      
      // 如果标签在可视区域外，滚动到合适位置
      if (tabLeft < scrollLeft) {
        // 标签在左侧不可见，滚动到标签位置
        container.scrollTo({
          left: tabLeft - 20, // 留 20px 边距
          behavior: 'smooth'
        })
      } else if (tabLeft + tabWidth > scrollLeft + containerWidth) {
        // 标签在右侧不可见，滚动到标签可见
        container.scrollTo({
          left: tabLeft + tabWidth - containerWidth + 20, // 留 20px 边距
          behavior: 'smooth'
        })
      }
    }
  })
}

// 监听 activeTab 变化，自动滚动到可见位置
watch(activeTab, () => {
  scrollToActiveTab()
})

// 关闭标签页
const closeTab = (key) => {
  const index = openedTabs.value.findIndex(tab => tab.key === key)
  if (index === -1) return
  
  openedTabs.value.splice(index, 1)
  
  // 如果关闭的是当前标签，切换到其他标签
  if (activeTab.value === key) {
    if (openedTabs.value.length > 0) {
      // 优先切换到右边的标签，否则切换到左边
      const nextTab = openedTabs.value[index] || openedTabs.value[index - 1]
      switchTab(nextTab.key)
    } else {
      // 没有标签了，回到工作台
      router.push('/home/dashboard')
    }
  }
}

const handleCommand = (command) => {
  switch (command) {
    case 'profile':
      ElMessage.info('个人中心')
      break
    case 'settings':
      ElMessage.info('账户设置')
      break
    case 'logout':
      // 清除本地 token 和用户信息
      removeToken()
      localStorage.removeItem('userInfo')
      ElMessage.success('退出登录')
      router.push('/login')
      break
  }
}
</script>

<style scoped>
.layout-container {
  display: flex;
  height: 100vh;
  width: 100%;
  background-color: #f5f7fa;
}

/* 左侧边栏 */
.sidebar {
  background: linear-gradient(180deg, #1a2332 0%, #2c3e50 100%);
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  transition: width 0.3s;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.sidebar::-webkit-scrollbar {
  width: 6px;
}

.sidebar::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.logo-section {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 20px;
  background: rgba(0, 0, 0, 0.2);
  transition: all 0.3s;
}

.logo-section.is-collapse {
  padding: 24px 10px;
}

.sidebar-logo {
  width: 40px;
  height: 40px;
  margin-right: 12px;
  border-radius: 8px;
  transition: all 0.3s;
}

.logo-section.is-collapse .sidebar-logo {
  margin-right: 0;
}

.sidebar-title {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.sidebar-menu {
  border-right: none;
  background-color: transparent;
}

:deep(.el-menu) {
  background-color: transparent;
  border: none;
}

:deep(.el-menu-item) {
  color: rgba(255, 255, 255, 0.8);
  margin: 4px 12px;
  border-radius: 8px;
  transition: all 0.3s;
}

:deep(.el-menu--collapse .el-menu-item) {
  margin: 4px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep(.el-menu-item:hover) {
  background-color: rgba(64, 158, 255, 0.1);
  color: #409eff;
}

:deep(.el-menu-item.is-active) {
  background: #409eff;
  color: #fff;
  font-weight: 500;
}

:deep(.el-sub-menu__title) {
  color: rgba(255, 255, 255, 0.8);
  margin: 4px 12px;
  border-radius: 8px;
  transition: all 0.3s;
}

:deep(.el-menu--collapse .el-sub-menu__title) {
  margin: 4px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep(.el-sub-menu__title:hover) {
  background-color: rgba(64, 158, 255, 0.1);
  color: #409eff;
}

:deep(.el-sub-menu .el-menu-item) {
  margin: 4px 8px;
  min-width: auto;
}

:deep(.el-menu--collapse .el-menu-item .el-icon) {
  margin-right: 0;
}

:deep(.el-menu--collapse .el-sub-menu__title .el-icon) {
  margin-right: 0;
}

/* 禁用子菜单展开动画 */
:deep(.el-menu--vertical .el-menu) {
  transition: none;
}

:deep(.el-menu--popup) {
  min-width: 180px;
}

/* 右侧主容器 */
.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 顶部导航栏 */
.header {
  background: linear-gradient(90deg, #fff 0%, #f8f9fa 100%);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  z-index: 10;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.menu-icon {
  font-size: 22px;
  cursor: pointer;
  color: #606266;
  transition: all 0.3s;
}

.menu-icon:hover {
  color: #409eff;
  transform: scale(1.1);
}

.breadcrumb {
  font-size: 14px;
}

.header-right {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 8px;
  transition: all 0.3s;
}

.user-info:hover {
  background-color: #f5f7fa;
}

.username {
  color: #303133;
  font-size: 14px;
  font-weight: 500;
}

/* 主内容区 */
.main-content {
  background-color: #f5f7fa;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 标签页容器 */
.tabs-container {
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
  padding: 0 20px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.tabs-wrapper {
  display: flex;
  gap: 4px;
  overflow-x: auto;
  overflow-y: hidden;
}

.tabs-wrapper::-webkit-scrollbar {
  height: 0;
}

.tab-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #2c3e50;
  border-radius: 4px 4px 0 0;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
  font-size: 14px;
  color: #fff;
  margin-top: 4px;
}

.tab-item:hover {
  background: #34495e;
}

.tab-item.active {
  background: #1a252f;
  color: #fff;
  font-weight: 500;
}

/* 子标签样式 */
.tab-item.sub-tab {
  padding: 6px 12px;
  font-size: 13px;
  background: #fff;
  color: #606266;
  border: 1px solid #dcdfe6;
  margin-top: 6px;
}

.tab-item.sub-tab:hover {
  background: #f5f7fa;
  border-color: #c0c4cc;
}

.tab-item.sub-tab.active {
  background: #fff;
  color: #409eff;
  border-color: #409eff;
  font-weight: 500;
}

.tab-title {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tab-close {
  font-size: 14px;
  transition: all 0.3s;
}

.tab-close:hover {
  transform: scale(1.2);
  color: #f56c6c;
}

/* 内容区域 */
.content-area {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .sidebar {
    position: fixed;
    z-index: 1000;
  }
  
  .breadcrumb {
    display: none;
  }
  
  .tabs-container {
    padding: 0 10px;
  }
  
  .content-area {
    padding: 10px;
  }
}
</style>
